export class GameType {
  GameTypeID: number;
  ShortDesc: string;
  LongDesc: string;

  constructor(data: IGameTypeData) {
    this.GameTypeID = data.GameTypeID;
    this.ShortDesc = data.ShortDesc;
    this.LongDesc = data.LongDesc;
  }
}
